$(function () {

    // glue orhaned words on last line with nbsp
    $('.article-title, .lead').each((i, title) => {
        let $title = $(title);
        let t = $title.text().trim();
        t = t.slice(0, -11) + t.slice(-11, t.length).replace(/ /g, ' ');
        $title.text(t);
    });
    
    // move opening quote marks outside column
    $('blockquote, .lead').each((i, title) => {
        let $title = $(title);
        let t = $title.text().trim();
        if (t[0] == '“') {
            $title.html(`<span style="margin-left: -0.36em">${ t.slice(0,1) }</span>` + t.slice(1));
        }
    });

    $('.video-square').each((i, el) => {
        el.setAttribute('playsinline', '');
    });


    $('article a').each((i, el) => {
        if (el.href && el.href.indexOf(location.origin) == -1) {
            el.setAttribute('target', '_blank');
            el.setAttribute('rel', 'noopener noreferrer');
        }
    });

});